<template>
    <v-dialog v-model="showDialog.unique" persistent max-width="500" class="px-5">
        <v-card>
            <v-toolbar flat dark color="primary">
                <v-toolbar-title>
                    <div class="row">
                        <span class="text-right col-md"> متن و عنوان غیرتکراری</span>

                        <span v-if="expireTime !== ''  && expireTime>0" class="float-left col-md mr-11">زمان باقی مانده : {{ parseInt(expireTime / 60) + ":" + (expireTime % 60) }} </span>
                    </div>

                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn icon dark @click="deleteOptions">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pt-5">
                <div v-if="expireTime === ''  || expireTime<0">
                    <v-text-field :error-messages="productMessage" dense clearable v-model="keyword" label="نام محصول / خدمات" outlined clear-icon="mdi-close-circle-outline"></v-text-field>

                    <v-btn v-if="productMessage === '' && keyword !== '' " class="btn-dec-with-text ml-auto" @click="getSuggest">
                        <span class="fa fa-save ml-1" style="font-size: 1.2rem"></span>
                        ثبت پیشنهادات
                    </v-btn>
                </div>
                <v-autocomplete label="عنوان پیشنهادی"
                                v-if="suggestTexts.titles != null"
                                chips
                                v-model="titleValue"
                                deletable-chips
                                :items="suggestTexts.titles"
                                prepend-inner-icon="fa fa-pencil-alt"
                >
                </v-autocomplete>
                <v-autocomplete label="توضیحات پیشنهادی"
                                v-if="suggestTexts.descriptions !== null"
                                chips
                                v-model="descriptionValue"
                                deletable-chips
                                :items="suggestTexts.descriptions"
                                prepend-inner-icon="fa fa-pencil-alt"
                >
                </v-autocomplete>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {Axios2} from "../../../../main";

export default {
    name: "UniqModal",
    props: {
        showDialog: {
            required: true,
        },
        advertise: {
            required: true
        }
    },
    data() {
        return {
            productMessage: null,
            suggestTexts: {
                titles: null,
                descriptions: null,
            },
            keyword: "",
            expireTime: "",
            titleValue: "",
            descriptionValue: "",
        }
    },
    methods: {
        deleteOptions() {
            this.showDialog.unique = false;

            if (this.titleValue != null || this.titleValue !== '' || this.titleValue !== undefined)
                this.suggestTexts.titles.splice(this.suggestTexts.titles.indexOf(this.titleValue), 1);

            if (this.descriptionValue != null || this.descriptionValue !== '' || this.descriptionValue !== undefined)
                this.suggestTexts.descriptions.splice(this.suggestTexts.descriptions.indexOf(this.descriptionValue), 1);

            this.advertise.title = this.titleValue
            this.advertise.description = this.descriptionValue
        },
        getSuggest() {
            this.$modal.showLoading();

            if (this.expireTime === '') {
                Axios2.post('/shop/default', JSON.stringify({
                    "category": this.advertise.category,
                    "city": String(this.advertise.location.city),
                    "keyword": this.keyword,
                    "length": 10
                })).then((response) => {
                    this.$modal.hideLoading();

                    if (response.data.data.length <= 0) {
                        this.$modal.error('خطا!', 'اطلاعات آگهی و یا نام محصول صحیح نیست.');
                    } else {
                        this.suggestTexts.titles = response.data.data.map(x => x.title);

                        this.suggestTexts.descriptions = response.data.data.map(x => x.description);

                        this.setCookies(this.advertise.category, JSON.stringify(response.data.data), 10);
                    }

                }).catch(() => {
                    this.$modal.error('خطا!', 'لطفا اطلاعات فرم را تکمیل فرمایید!');
                })
            } else this.$modal.info('هشدار!', 'تاپایان زمان باقی مانده شما قادر به ایجاد درخواست جدید نیستید.')
        },
        setCookies(key, value, min) {
            const d = new Date();

            d.setTime(d.getTime() + (min * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            localStorage.setItem(key, value);
            document.cookie = key + "_expire=" + expires.replace("expires=", "");
        },
        getCookie(key) {
            let cookies = document.cookie.split(";")
            let now = new Date();

            let newCookies = cookies.filter((item) => item.indexOf("_expire") > -1).map((item) => {
                let expire_cookie = item.trim().split("=");
                let cookie = cookies.find(x => x.indexOf(expire_cookie[0].replace("_expire", "") + "=") > -1)?.trim()?.split("=") || [];
                let expire = new Date(expire_cookie[1]);
                this.expireTime = parseInt((expire.getTime() / 1000) - (now.getTime() / 1000));

                return {
                    name: expire_cookie[0].replace("_expire", ""),
                    value: this.expireTime > 0 ? localStorage.getItem(key) : null,
                    expire_at: parseInt((expire.getTime() / 1000) - (now.getTime() / 1000))
                }
            });

            return newCookies.find((item) => item.name === key);
        }
    },
    watch: {
        keyword: function (value) {
            const syllables = value.split(' ').filter(x => x);

            if (syllables.length < 2)
                this.productMessage = 'حداقل 2 کلمه باید وارد شود';
            else if (syllables.length >= 5)
                this.productMessage = 'حداکثر 4 کلمه باید وارد شود';
            else
                this.productMessage = '';
        },
    },
    mounted() {
        const cacheData = JSON.parse(this.getCookie(this.advertise.category).value);

        this.suggestTexts.titles = cacheData.map(x => x.title);
        this.suggestTexts.descriptions = cacheData.map(x => x.description);
    }
}
</script>

<style scoped>

</style>